import {
    DatiqInputTypes,
    IDatiqOption,
    emptyDatiqInput,
} from '@dat/datiq-components-pkg/utils';
import {
    DATIQ_DEFAULT_ARRAY,
    DATIQ_DEFAULT_BOOLEAN,
    DATIQ_INPUT_SELECT,
    datiqInputCreateId,
} from '@dat/datiq-core/models';
import {
    DatiqSelectEnumAppearance,
    DatiqSelectEnumStyle,
    IDatiqSelect,
} from './datiq-select.interface';

export const DATIQ_SELECT_ID: (id: string) => string = (id: string) =>
    datiqInputCreateId([id, DATIQ_INPUT_SELECT]);

export const emptyDatiqSelect: IDatiqSelect = {
    ...emptyDatiqInput,
    type: DatiqInputTypes.Select,
    options: DATIQ_DEFAULT_ARRAY as IDatiqOption[],
    multiple: DATIQ_DEFAULT_BOOLEAN,
    appearance: DatiqSelectEnumAppearance.Outline,
    style: DatiqSelectEnumStyle.Standard,
};
